import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.739 8c0-3.436 2.724-6.222 6.084-6.222 3.361 0 6.085 2.786 6.085 6.222v.52l-1.124-1.148-1.229 1.256 3.223 3.296L18 8.628l-1.23-1.256-1.123 1.149V8c0-4.419-3.502-8-7.824-8C3.503 0 0 3.581 0 8s3.502 8 7.823 8a7.7 7.7 0 0 0 4.891-1.755l-1.088-1.387a5.98 5.98 0 0 1-3.803 1.364c-3.36 0-6.084-2.785-6.084-6.222M7.2 6.174v5.382H9V4.444H7.385L4.995 5.83l.76 1.234z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "rotate-right-one"}) } }